import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const analiseDocumentalRoutes: Routes = [
  {
    path: 'analise-documental',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Gerenciar Análise',
      roles: [Role.ANALISE_DOCUMENTAL_CONSULTAR, Role.ANALISE_DOCUMENTAL_EDITAR],
      breadcrumb: [{ label: 'Análise Documental', url: '/analise-documental' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./lista-candidatos.component').then(
            (m) => m.ListaCandidatosComponent,
          ),
        data: {
          title: 'Análise Documental',
          roles: [Role.ANALISE_DOCUMENTAL_CONSULTAR, Role.ANALISE_DOCUMENTAL_EDITAR],
          breadcrumb: [{ label: 'Análise Documental', url: '/analise-documental' }],
        },
      },
      {
        path: 'analise-individual/:inscricaoCicloId',
        loadComponent: () =>
          import('./analise-individual/analise-individual.component').then(
            (m) => m.AnaliseIndividualComponent,
          ),
        data: {
          title: 'Análise Individual',
          roles: [Role.ANALISE_DOCUMENTAL_CONSULTAR, Role.ANALISE_DOCUMENTAL_EDITAR],
          breadcrumb: [
            { label: 'Análise Documental', url: '/analise-documental' },
            { label: 'Análise Individual' },
          ],
        },
      },
    ],
  },
];
